<template>
  <div>
    <pdfTemplate ref="pdfTemplate" :data="data" @close="handleClose" @getPONo="getPONo" @refresh="getData"/>
    <div class="app-container">
      <!-- 入库信息 -->
      <BjDivider>
        {{ $t('BusinessPurchaseOrder3.Warehouse') }}
      </BjDivider>
      <el-table :data="data.purchaseOrderReceives" border script max-height="600">
        <el-table-column :label="$t('table.countText')" type="index" align="center" :min-width="60" />
        <el-table-column :label="$t('BusinessPurchaseOrder3.Date')" prop="creationDate" align="center">
          <template slot-scope="{ row }">{{ row.creationDate | timeFilters }}</template>
        </el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrder2.Unit')" prop="shippingMethod" align="center"></el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrder3.ContainerId')" prop="actualContainerNo" align="center"></el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrder3.Size')" prop="containerLength" align="center"></el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrder3.Type')" prop="containerType" align="center"></el-table-column>
        <el-table-column prop="totalPalletQty" :label="$t('BusinessPurchaseOrder3.Total')" align="center" />
        <el-table-column prop="csgPallet" :label="$t('BusinessPurchaseOrder3.Hire')" align="center" />
        <el-table-column :label="$t('BusinessPurchaseOrder3.CustomerPalletQty')" align="center">
          <el-table-column prop="standardPallet" :label="$t('BusinessPurchaseOrder3.Standard')" align="center" />
          <el-table-column prop="chepPallet" :label="$t('BusinessPurchaseOrder3.Chep')" align="center" />
          <el-table-column prop="loscomPallet" :label="$t('BusinessPurchaseOrder3.Loscom')" align="center" />
          <el-table-column prop="nonStandardPallet" :label="$t('BusinessPurchaseOrder3.nonStandard')" align="center" />
        </el-table-column>
        <el-table-column prop="cartonQty" :label="$t('BusinessPurchaseOrder3.cartonQty')" align="center" />
        <el-table-column prop="labourTime" :label="$t('BusinessPurchaseOrder3.Extra')" align="center" />
        <el-table-column prop="comments" :label="$t('BusinessPurchaseOrder3.comments')" align="center" />
        <el-table-column prop="createdName" :label="$t('BusinessPurchaseOrder3.Submitter')" align="center" />
      </el-table>
    </div>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { purchaseApi } from '@/api';
import { STATUS_YES_TRUE } from '@/utils/constants';
import pdfTemplate from '@/views/center-business/purchase/order/components/pdfTemplate';

export default {
  name: 'BusinessPurchaseOrderCsgAdminDetail',
  components: { pdfTemplate },
  mixins: [viewMiXin],
  props: {
  },
  data() {
    return { STATUS_YES_TRUE, data: {} };
  },
  computed: {},
  watch: {},
  async mounted() {
    // await purchaseApi.getPoArrivalSync({code: this.$route.query.code});
    this.getData();
  },
  methods: {
    handleClose() {
      this.cancel();
    },
    getData() {
      purchaseApi['getCsgPurchaseOrderDetail']({
        id: this.$route.query.id,
      }).then(async res => {
        const skuList = res.purchaseOrderGoods.map(item => item.skuCode);
        purchaseApi.purchaseGoodsImport(skuList).then(res2 => {
          res.purchaseOrderReceives.forEach(item => {
            this.$set(item, 'actualContainerNo', res.actualContainerNo);
          });
          res.purchaseOrderGoods.forEach(item => {
            res2.forEach(jitem=>{
              if (item.skuCode === jitem.skuCode) {
                this.$set(item, 'barCode', jitem.barCode);
                // this.$set(item, 'expiryDate', jitem.expiryDate);
                // this.$set(item, 'batchCode', jitem.batchCode);
              }
            })
          });
          this.data = res;
          this.$refs.pdfTemplate.cloneRemarks(res);
        });
      });
    },
    // 同步到货数量
    getPONo() {
      const id = this.data.code;
      purchaseApi.getPoArrivalSync({code: id}).then(res => {
        if (res?.failed == false || res.message == 'Sync successful') {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.getData();
        }
      });
    },
  },
};
</script>
